import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../../models/chips-and-fields';

@Component({
  selector: 'app-date-standard',
  templateUrl: './dateStandard.component.html',
  styleUrls: ['./dateStandard.component.css']
})
export class DateStandardComponent implements OnInit {

  @Input() public field: Field;
  @Input() public parentFormGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
